import { PagedSearch } from 'src/app/shared';

export class CreditTypeSearchDto extends PagedSearch {
  Keyword: string;
  CECreditType: string;
  Descr: string;
  AccreditationCycleMonths: number;
  DateChanged: Date;
  DateCreated: Date;
  ChangedBy: string;
}
